import type { ColumnsType } from 'antd/lib/table';

export type SitesPopularity = {
  name: string;
  submissions: number;
  clients: number;
};

export const sitesColumns: ColumnsType<SitesPopularity> = [
  {
    title: 'Site',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Clients',
    dataIndex: 'clients',
    key: 'clients',
  },
  {
    title: 'Check-ins',
    dataIndex: 'submissions',
    key: 'submissions',
  },
];
